import React, { PropTypes } from 'react';

export default class ChangePassword extends React.Component {

	constructor(props) {
		super(props);
		this.state = { isFetching: false, message: "", status: "" };
	}

	handleSubmit(e) {
		e.preventDefault();
		e.stopPropagation();
		
		const currPw = this.isNewPassword() ? null : this._currentPw.value;
		const newPw = this._newPw.value;
		const confirmPw = this._confirmPw.value;

		if ( !newPw || !confirmPw ) {
			this.setState({status: "ERROR", message: "Preencha todos os campos."});
			return;
		}

		if ( newPw !== confirmPw ) {
			this.setState({status: "ERROR", message: "Senhas não conferem!"});
			return;
		}

		this.setState({isFetching: true});

		// Call action
		if (this.isNewPassword()) {
			const _token = window.location.search.split('=')[1];
			this.props.newPassword(newPw, _token, this.onSuccess.bind(this), this.onError.bind(this));
		} else {
			this.props.changePassword(newPw, currPw, this.onSuccess.bind(this), this.onError.bind(this));
		}
	}

	onSuccess() {
		this.setState({isFetching: false, message: "Alteração feita com sucesso!", status: "SUCCESS"});
		this._currentPw.value = "";
		this._newPw.value = "";
		this._confirmPw.value = "";
	}

	onError() {
		if (this.isNewPassword()) {
			this.setState({isFetching: false, message: "Algo deu errado.", status: "ERROR"});
		} else {
			this.setState({isFetching: false, message: "Senha incorreta", status: "ERROR"});
		}
	}

	additionalText() {			
		if ( this.state.isFetching ) return <i className="fas fa-circle-notch fa-spin " />;
		return <span style={{color: this.state.status === "SUCCESS" ? "green" : "red"}}>{this.state.message}</span>;
	}

	isNewPassword() {
		return window.location.pathname === '/new_password';
	}
	
	titulo() {
		return this.isNewPassword() ? 'Nova Senha' : 'Trocar Senha';
	}

	senhaAtual() {
		return this.isNewPassword() ? null : (
			<div className="form-group">
				<label>Senha Atual</label>
				<input type="password" className="form-control" ref={(node) => this._currentPw = node} />
			</div>
		);
	}

	render () {
		return (
			<div className="container login-box cs-card">
				<h2 className="text-center">{this.titulo()}</h2>				
				<hr />				
				<form onSubmit={this.handleSubmit.bind(this)}>
					{this.senhaAtual()}
					<div className="form-group">
						<label>Nova Senha</label>
						<input type="password" className="form-control" ref={(node) => this._newPw = node} />
					</div>
					<div className="form-group">
						<label>Confirme a Nova Senha</label>
						<input type="password" className="form-control" ref={(node) => this._confirmPw = node} />
					</div>					
					<button 
						type="submit"
						disabled={this.state.isFetching}
						className="btn btn-primary">
						Enviar
					</button>
					<span style={{padding: "10px"}}>
						{this.additionalText()}
					</span>
				</form>
			</div>
		);
	}
}

ChangePassword.propTypes = {
	changePassword: PropTypes.func.isRequired,
	newPassword: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Login/ChangePassword.js